import * as Types from '../types';

class Auth {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mfa: any;

  constructor() {
    this.mfa = window.mfa;
  }

  getSessionId(): string | null {
    try {
      return this.mfa.getSessionId();
    } catch (e) {
      return null;
    }
  }

  authOTP(returnUrl?: string): void | null {
    try {
      return this.mfa.authOTP(returnUrl);
    } catch (e) {
      return null;
    }
  }

  login(
    sessionId: string,
    onSuccess?: Types.MfaLoginOnSuccess,
    onFailure?: Types.MfaOnFailure
  ): Types.MfaLoginOnSuccess | Types.MfaOnFailure | null {
    try {
      return this.mfa.login(sessionId, onSuccess, onFailure);
    } catch (e) {
      return null;
    }
  }

  logout(
    onSuccess?: Types.MfaOnSuccess,
    onFailure?: Types.MfaOnFailure
  ): Types.MfaOnSuccess | Types.MfaOnFailure | null {
    try {
      return this.mfa.logout(onSuccess, onFailure);
    } catch (e) {
      return null;
    }
  }

  check(
    onSuccess?: Types.MfaOnSuccess,
    onFailure?: Types.MfaOnFailure
  ): Types.MfaOnSuccess | Types.MfaOnFailure | null {
    try {
      return this.mfa.check(onSuccess, onFailure);
    } catch (e) {
      return null;
    }
  }

  getUser(
    onSuccess?: Types.MfaGetUserOnSuccess,
    onFailure?: Types.MfaOnFailure
  ): Types.MfaGetUserOnSuccess | Types.MfaOnFailure | null {
    try {
      return this.mfa.getUser(onSuccess, onFailure);
    } catch (e) {
      return null;
    }
  }

  checkNotAuthorizedCookie(): boolean | null {
    try {
      return this.mfa.checkNotAuthorizedCookie();
    } catch (e) {
      return null;
    }
  }
}

const auth = new Auth();

export default auth;
